// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".buy-tokens-container[data-v-3ed4c03b] {\n  height: 100%;\n}\n.buy-tokens-container .back_container[data-v-3ed4c03b] {\n  text-align: left;\n  padding: 20px 20px;\n}\n.buy-tokens-container .back_container span[data-v-3ed4c03b]:hover {\n  cursor: pointer;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
